'use client';

import dynamic from 'next/dynamic';
import LazyLoad from 'react-lazyload';

interface Props {
  sku: string;
  reviewListAnChorId: string;
  originalUrlKey: string;
  productId: string;
}

const Reviews = dynamic(() => import('@/components/Reviews'), { ssr: false });

const ProductReviewsLazyLoad = (props: Props) => {
  const { sku, reviewListAnChorId, originalUrlKey, productId } = props;

  return (
    <LazyLoad>
      <Reviews
        sku={sku}
        reviewListAnChorId={reviewListAnChorId}
        originalUrlKey={originalUrlKey}
        productId={productId}
      />
    </LazyLoad>
  );
};

export default ProductReviewsLazyLoad;
